import {GLModel} from "./GLModel";
import {Camera} from "./Camera";
import {Matrix} from "./Matrix";

export interface IGLObject{
    Translate:(amount:Array<number>)=>void;
    Rotate:(amount:Array<number>)=>void;
    Draw:(camera:Camera,gl:WebGLRenderingContext) =>void;
}

export class GLObject {
    position:Array<number>;
    rotation:Array<number>;
    shader:WebGLProgram;
    model:GLModel;
    uniforms:Array<{name:string,val:any}>;
    constructor(shader:WebGLProgram,model:GLModel) {
        this.position = [0.0,0.0,0.0];
        this.rotation = [0.0,0.0,0.0];
        this.shader = shader;
        this.model = model;
        this.uniforms = [];
    }
    Translate(amount:Array<number>){
        this.position[0] += amount[0];
        this.position[1] += amount[1];
        this.position[2] += amount[2];
    }
    Rotate(amount:Array<number>){
        this.rotation[0] += amount[0];
        this.rotation[1] += amount[1];
        this.rotation[2] += amount[2];
    }
    Draw = (camera:Camera,gl:WebGLRenderingContext) => {
        const M = Matrix.identity(Matrix.create());
        Matrix.translate(M,this.position,M);
        Matrix.rotate(M,this.rotation[0],[1.0,0.0,0.0],M);
        Matrix.rotate(M,this.rotation[1],[0.0,1.0,0.0],M);
        Matrix.rotate(M,this.rotation[2],[0.0,0.0,1.0],M);
        const V = camera.V;
        const P = camera.P;
        gl.useProgram(this.shader);
        const attLocation = gl.getAttribLocation(this.shader, 'position');
        const attStride = 3;
        gl.bindBuffer(gl.ARRAY_BUFFER, this.model.vbo);
        gl.enableVertexAttribArray(attLocation);
        gl.vertexAttribPointer(attLocation, attStride, gl.FLOAT, false, 0, 0);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.model.ibo);
        let uniLocation = gl.getUniformLocation(this.shader, 'mvpMatrix');
        gl.uniformMatrix4fv(uniLocation, false, Matrix.GenerateMVP(M,V,P));
        for(let i = 0; i < this.uniforms.length;i++){
            let uniLocation = gl.getUniformLocation(this.shader, this.uniforms[i].name);
            gl.uniform3fv(uniLocation, new Float32Array(this.uniforms[i].val));
        }
        gl.drawElements(gl.TRIANGLES, this.model.indexCount,gl.UNSIGNED_SHORT, 0);
    }
}